import DeclinedTable from "./DeclinedTable";

export default DeclinedTable